<template>
	<div :dir="dir">
		<el-form-item
			v-if="generalMethods.valueExist(prop)"
			:label="hideLabel ? null : generalMethods.translate(label)"
			:for="id == null ? prop : id"
			:prop="prop"
			:rules="rules"
			:class="`${elFormItemClassses}`"
			:required="required"
		>
			<DateCore
				:id="id == null ? prop : id"
				v-model="localModelValue"
				:dir="dir"
				@change="(value) => emitEvent('change', value)"
				:label="ariaLabel"
				:disabled="disabled"
				:readonly="readonly"
				:placeholder="placeholder"
				:size="size"
				:autofocus="autofocus"
				:disabledDates="disabledDates"
			/>
			<template v-if="!hideLabel" #label>
				<slot name="label" />
			</template>
		</el-form-item>
		<DateCore
			v-else
			:id="id == null ? prop : id"
			v-model="localModelValue"
			:dir="dir"
			@change="(value) => emitEvent('change', value)"
			:label="ariaLabel"
			:disabled="disabled"
			:readonly="readonly"
			:placeholder="placeholder"
			:size="size"
			:autofocus="autofocus"
			:disabledDates="disabledDates"
		/>
	</div>
</template>
<script lang="ts">
import { computed, defineComponent } from "vue";

import DateCore from "@/components/element-plus/DateCore.vue";

import * as generalMethods from "@/core/mixins/general_methods";
import * as customValidation from "@/core/mixins/custom_validation";

export default defineComponent({
	name: "umt-element-plus-input",
	props: {
		id: { type: String, default: null },
		label: { type: String, default: null },
		prop: { type: String, default: null },
		modelValue: {},
		dir: { type: String, default: null },
		rows: { type: Number, default: null },
		ariaLabel: { type: String, default: null },
		disabled: { type: Boolean, default: false },
		readonly: { type: Boolean, default: false },
		extraRules: { type: Array, default: null },
		showPrepend: { type: Boolean, default: false },
		placeholder: { type: String, default: null },
		hideLabel: { type: Boolean, default: false },
		size: { type: String, default: "default" },
		elFormItemClassses: { type: String, default: "" },
		autofocus: { type: Boolean, default: false },

		//validations
		required: { type: Boolean, default: false },
		disabledDates: { type: Number, default: null },
	},
	components: {
		DateCore,
	},
	setup(props, { emit }) {
		const localModelValue = computed({
			get() {
				return props.modelValue;
			},
			set(newValue) {
				emit("update:modelValue", newValue);
			},
		});

		const rules = computed(() => {
			let rules = [] as Array<any>;

			if (props.required) {
				rules.push({
					validator: (rule, value, callaback) => {
						customValidation.required(rule, value, callaback, props.label);
					},
				});
			}

			if (props.extraRules != null) {
				rules = rules.concat(props.extraRules);
			}

			return rules;
		});

		const emitEvent = (event, value) => {
			emit(event, value);
		};

		return {
			generalMethods,
			customValidation,

			localModelValue,

			rules,

			emitEvent,
		};
	},
});
</script>
